import React, {FC, createContext, useContext} from 'react'

const I18N_CONFIG_KEY = process.env.REACT_APP_I18N_CONFIG_KEY || 'i18nConfig'

type Props = {
  selectedLang: 'de' | 'en' | 'es' | 'fr' | 'ja' | 'zh' | 'pt' | 'it' | 'ko'
}
const initialState: Props = {
  selectedLang: 'pt',
}

function getConfig(): Props {
  const ls = localStorage.getItem(I18N_CONFIG_KEY)

  if (ls) {
    try {
      const parsed = JSON.parse(ls) as Props
      return parsed
    } catch (er) {
      console.error('🚨 Metronic getConfig - parse error:', er)
    }
  }
  return initialState
}

// Side effect
export function setLanguage(lang: string) {
  localStorage.setItem(I18N_CONFIG_KEY, JSON.stringify({selectedLang: lang}))
  window.location.reload()
}

const I18nContext = createContext<Props>(initialState)

const useLang = () => {
  return useContext(I18nContext).selectedLang
}

type PropsProvider = {
  children?: React.ReactNode
}

const MetronicI18nProvider: FC<PropsProvider> = ({children}) => {
  const lang = getConfig()
  return <I18nContext.Provider value={lang}>{children}</I18nContext.Provider>
}

export {MetronicI18nProvider, useLang}
